import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import NumberField from "components/NumberField"
import { Formik, Field, Form } from "formik"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import { loadingStatus, getPayload } from "actions"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class MarketingModels extends Component {
	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "Builder",
					accessor: "builder",
					name: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					name: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Address",
					accessor: "address",
					name: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "address"),
				},
				/* {
					Header: "Description",
					accessor: "marketing_description",
					name: "Description",
				}, */
				{
					Header: "Virtual Tour",
					accessor: "virtual",
					name: "Virtual",
				},
				{
					Header: "From The",
					accessor: "model_from_the",
					name: "From The",
				},
				{
					Header: "Show In Feed?",
					accessor: "model_show_in_feed",
					name: "Show In Feed?",
				},
			],
			loaded: false,
			filtered: [],
			sorted: [],
			showFilters: false,
			fields: {
				rows: [
					{
						marketing_description: "",
						model_from_the: "",
					},
				],
			},
			data: [],
			acceptableToSend: ["id", "marketing_description", "model_from_the", "virtual", "model_show_in_feed"],
		}
	}

	componentDidMount() {
		this.initialData()
	}
	
	componentDidUpdate(prevProps) {
		if(!_.isEqual(prevProps, this.props)) {
			this.initialData()
		}
	}

	initialData = () => {
		let data = {}
		_.forEach(this.props.payload.exec.lots, (v, k) => {
			if (!v.model) {
				return
			}
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			data[v.address] = {
				id: v.id,
				builder: builder ? builder.name : "",
				address: v.address,
				lot_type: type ? type.name : "",
				virtual: v.virtual,
				//marketing_description: v.marketing_description || "",
				model_from_the: v.model_from_the,
				model_show_in_feed: v.model_show_in_feed ? true : false,
			}
		})
		this.setState({ data, loaded: true }, () => {
			//console.log(this.state)
		})
	}

	supply = (f) => {
		let ret = []
		_.forEach(this.state.data, (v, k) => {
			//f.setFieldValue(`rows[${k}].marketing_description`, v.marketing_description || '')
			ret.push({
				builder: v.builder,
				address: v.address,
				lot_type: v.lot_type,
				virtual: (
					<Field
						name={`${v.address}.virtual`}
						className="form__input"
						value={f.values[v.address].virtual || ""}
					/>
				),
				/*marketing_description: (
					<HTMLEditor
						name={`${v.address}.marketing_description`}
						value={f.values.rows[k].marketing_description}
						className="form__textarea"
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
					/>
				),*/
				model_from_the: (
					<NumberField
						name={`${v.address}.model_from_the`}
						type="text"
						className="form__input"
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						value={f.values[v.address].model_from_the}
					/>
				),
				model_show_in_feed: (
					<Field
						type="checkbox"
						name={`${v.address}.model_show_in_feed`}
						className="form__input"
						//value={f.values[v.address].model_show_in_feed}
					/>
				),
			})
		})
		return ret
	}

	render() {
		if (this.props.payloadStatus && this.state.loaded) {
			return (
				<div className="models">
					<div className="imageGroup">
						<Title title="Marketing Models" />
						<div className="content inventory__content">
							<Formik
								enableReinitialize
								initialValues={this.state.data}
								validationSchema={this.validation}
								validateOnMount={true}
								onSubmit={(values) => {
									console.log(values)
									this.props.loadingStatus(true)
									let vals = []
									_.forEach(values, (v) => {
										let ret = {}
										_.forEach(this.state.acceptableToSend, (r) => {
											ret[r] = v[r]
										})
										//ret = helpers.clean(ret)
										// if only one key in object, skip
										let keys = Object.keys(ret)
										if (keys.length <= 1) {
											//return
										}
										vals.push(ret)
									})
									submitData("updateModels", vals).then((data) => {
										this.props.loadingStatus(false)
										toast.success(data.message)
										this.props.getPayload()
									})
								}}
								render={(f) => (
									<div className="editCommunity">
										{/* console.log(f) */}
										<Form>
											<FullTable
												data={this.supply(f)}
												columns={this.state.columns}
												name="models"
												title="Models"
												unset={["edit"]}
											/>
											<div style={{ textAlign: "right" }}>
												<input
													type="submit"
													value="Submit"
													className={`form__submit form__submit--ready`}
												/>
											</div>
										</Form>
									</div>
								)}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MarketingModels)
